import {action, computed, makeObservable, observable} from 'mobx';
import {Form, FormDesignData} from '../Form/Form';
import {priority} from '@priority-software/priority-proto-api/lib';
import {createDefaultDesign, getNonEmptyTabs} from './utils/formDesignUtils';

export class FormDesign {
    form: Form = null;

    @observable.shallow tableColumnsDesign = [];
    @observable.shallow rowViewColumnsDesign = [];
    @observable.shallow actionsDesign = [];
    @observable.shallow subformsDesign = [];

    @observable showPicture = false;

    constructor(initialData: FormDesignData = {}, form: Form) {
        makeObservable(this);

        const defaults = createDefaultDesign(initialData);

        this.showPicture = defaults.showPicture;
        this.tableColumnsDesign = [...defaults.tableViewColumnsDesign];
        this.rowViewColumnsDesign = [...defaults.rowViewColumnsDesign];
        this.actionsDesign = [...defaults.actionsDesign];
        this.subformsDesign = [...defaults.subformsDesign];

        this.form = form;
    }

    @action setTableColumnsDesign(columns: priority.netitems.form.ITableViewColumnsDesign[]) {
        this.tableColumnsDesign = [...columns];
    }

    @action setRowViewColumnsDesign(columns: priority.netitems.form.IRowViewTabsDesign[]) {
        this.rowViewColumnsDesign = getNonEmptyTabs([...columns]);
    }

    @action setActionsDesign(actions: priority.netitems.form.IMenuDesign[]) {
        this.actionsDesign = [...actions];
    }

    @action setSubformsDesign(subforms: priority.netitems.form.IMenuDesign[]) {
        this.subformsDesign = [...subforms];
    }

    @action togglePicture(show: boolean) {
        this.showPicture = show;
    }

    @computed get nonEmptyTabsView() {
        return getNonEmptyTabs(this.rowViewColumnsDesign);
    }
}
